import styled from 'styled-components';

import { IconButton } from '@components/icon-button';
import { IconFile } from '@components/icons/file';
import { IconOpenPreview } from '@components/icons/open-preview';
import { IconTrash } from '@components/icons/trash';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { lineClamp } from '@styles/layout-helpers';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type FileTagProps = {
  name: string;
  onPreview?: () => void;
  onRemove?: () => void;
};

export const FileTag = ({ name, onPreview, onRemove }: FileTagProps) => {
  return (
    <StyledFileTag $hasActions={Boolean(onPreview || onRemove)}>
      <IconFile color="elementBlue100" size={16} />
      <Text
        font="regular12"
        text={name}
        tooltip={name}
        style={{
          flex: '1 1 auto',
          minWidth: 0,
          ...lineClamp('-webkit-box', 1, true),
        }}
      />
      <Actions>
        {onPreview && (
          <IconButton
            icon={<IconOpenPreview />}
            variant="ghost-purple"
            size="sm"
            onClick={onPreview}
          />
        )}
        {onRemove && (
          <IconButton
            icon={<IconTrash color="buttonIconPositive" />}
            variant="ghost-purple"
            size="sm"
            onClick={onRemove}
          />
        )}
      </Actions>
    </StyledFileTag>
  );
};

const StyledFileTag = styled(Stack).attrs({
  orientation: 'horizontal',
  space: 2,
  align: 'center',
})<{ $hasActions: boolean }>((p) => {
  return {
    border: `1px solid ${theme.color.border10}`,
    borderRadius: pxToRem(8),
    padding: p.$hasActions ? `${pxToRem(4)} ${pxToRem(8)}` : pxToRem(8),
    width: '100%',
    minWidth: 0,
  };
});

const Actions = styled(Stack).attrs({
  orientation: 'horizontal',
  space: 1,
  align: 'center',
})({});
